'use strict';
'use es6';
// make sure we support IE11 when triggering events

Object.defineProperty(exports, "__esModule", {
  value: true
});
var triggerEvent = exports.triggerEvent = function triggerEvent(eventName, data) {
  var event = void 0;
  if (typeof window.Event === 'function') {
    event = Object.assign(new Event(eventName), data);
  } else {
    event = Object.assign(document.createEvent('Event'), data);
    event.initEvent(eventName, true, true);
  }

  window.dispatchEvent(event);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hub-http/static-1.158/js/helpers/events.js
// module id = 378
// module chunks = 0